'use client';

import Image from '@eliadmin/core/src/components/image/image-wrapped';

import type { ProductDetailData } from '@eliadmin/core/src/api/products/types/product-types';

import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';
import { useVariantsStore } from '@eliadmin/core/src/stores/variant-store';
import { getProductPriceDisplay } from '@eliadmin/core/src/utils/product-price-utils';

export function ProductTags({ product }: { product: ProductDetailData }) {
  const selectedVariant = useVariantsStore(s => s.selectedVariant);

  const desiredObject = product.variants?.length ? selectedVariant : product;

  const priceDisplay = getProductPriceDisplay(desiredObject ?? product);
  const isDiscounted = priceDisplay.showPreviousPrice;

  const { t } = useTranslations();

  return (
    <div className="flex items-center justify-start gap-3 sm:gap-4">
      {product.quantity > 0 && (
        <div className="flex items-center justify-start gap-2">
          <Image
            src={'/images/icons/shield-tick.svg'}
            alt={selectedVariant?.name || product.name}
            width={24}
            height={24}
          />
          <p className="text-sm font-medium text-black sm:text-base">{t('text2297')}</p>
        </div>
      )}
      {isDiscounted && (
        <div className="flex items-center justify-start gap-2">
          <Image
            src={'/images/icons/receipt-discount.svg'}
            alt={selectedVariant?.name || product.name}
            width={24}
            height={24}
          />
          <p className="text-sm font-medium capitalize text-black sm:text-base">
            {t('text24')} -{priceDisplay.discountLabel}%
          </p>
        </div>
      )}
    </div>
  );
}
